var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisableChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3.75817,
    fill: "#E7E8F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 10.5,
    transform: "translate(4.5 6.75)",
    fill: "#E7E8F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.351 7.84335C19.5783 7.56053 19.5414 7.1402 19.2687 6.90452C18.9959 6.66884 18.5906 6.70705 18.3633 6.98987L13.7427 12.7393C12.8146 13.8941 12.1616 14.7041 11.5953 15.2343C11.0422 15.7522 10.6605 15.9168 10.2857 15.9168C9.91092 15.9168 9.52921 15.7522 8.9761 15.2343C8.40979 14.7041 7.75687 13.8941 6.82873 12.7392L5.63673 11.256C5.40944 10.9732 5.00407 10.935 4.73133 11.1707C4.45858 11.4064 4.42173 11.8267 4.64902 12.1095L5.8741 13.6339C6.76147 14.7381 7.47212 15.6224 8.11442 16.2238C8.7779 16.845 9.45612 17.25 10.2857 17.25C11.1153 17.25 11.7935 16.845 12.457 16.2238C13.0993 15.6224 13.8099 14.7381 14.6973 13.6339L19.351 7.84335Z",
    fill: "#A5AAD8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisableChecked);
export default __webpack_public_path__ + "static/media/disableChecked.aa900a1b570b301d487e67c93eba08ca.svg";
export { ForwardRef as ReactComponent };